// Pacific Key Management — Blog Content Manifest
// ------------------------------------------------
// SINGLE SOURCE OF TRUTH for all blog articles. Consumed by:
//   • /app/frontend/src/pages/Blog.jsx           — landing (featured + cards)
//   • /app/frontend/src/pages/BlogArticle.jsx    — individual article pages
//   • /app/frontend/scripts/routes.js            — enumerates URLs for prerender
//   • /app/frontend/scripts/generate-sitemap.js  — emits sitemap.xml entries
//   • /app/frontend/scripts/extract-blog-slugs.js — build-time slug extraction
//
// HOW TO ADD A NEW ARTICLE
// ------------------------
// 1. Create a new file:  src/content/blog/<your-slug>.js
//    Copy the shape of hurricane-preparation-los-cabos.js.
// 2. Import & register it in the ARTICLES array below.
// 3. Run:  cd frontend && yarn build && yarn bake-prerender && git commit
// 4. Deploy. That's it — sitemap and prerender pick it up automatically.
//
// The build-time slug extractor (extract-blog-slugs.js) reads THIS file
// with a regex, so keep the ARTICLES array literal and each entry's
// `slug` property as a plain string.

import hurricane from "./hurricane-preparation-los-cabos";
import preventiveMaintenance from "./preventive-maintenance-luxury-homes-los-cabos";
import essentialServices from "./essential-services-luxury-property-management-los-cabos";
import propertyManagement from "./property-management-los-cabos-luxury-homeowners";

// ORDER MATTERS: newest article first — the landing page uses ARTICLES[0]
// as the "Featured Article" hero.
export const ARTICLES = [
    propertyManagement,
    essentialServices,
    preventiveMaintenance,
    hurricane,
];

export const CATEGORIES = {
    "property-management": { en: "Property Management",   es: "Administración de Propiedades" },
    "home-care":        { en: "Home Care",             es: "Cuidado del Hogar" },
    "seasonal":         { en: "Seasonal Guides",       es: "Guías de Temporada" },
    "ownership":        { en: "Luxury Ownership",      es: "Propiedad de Lujo" },
    "communities":      { en: "Los Cabos Communities", es: "Comunidades de Los Cabos" },
    "concierge":        { en: "Concierge & Lifestyle", es: "Concierge y Estilo de Vida" },
};

export function getPublished() {
    return ARTICLES.filter((a) => a.status === "published");
}

export function getFeatured() {
    return getPublished()[0] || null;
}

export function getRest() {
    return getPublished().slice(1);
}

export function getBySlug(slug) {
    return ARTICLES.find((a) => a.slug === slug) || null;
}

// Localized article body. If a Spanish version has not been added yet,
// the page transparently falls back to English and surfaces a small
// bilingual notice. Add `es: { ... }` to an article file to enable Spanish.
export function localize(article, lang) {
    if (!article) return null;
    if (lang === "es" && article.es) return { ...article.es, _lang: "es", _fallback: false };
    return { ...article.en, _lang: "en", _fallback: lang === "es" };
}
